// renewalFormQuestions.ts

export type QuestionType = "radio" | "text" | "number";

export interface Question {
  id: number;
  key: string;
  label: string;
  type: QuestionType;

  // Only for radio conditional logic
  yesAction?: {
    message: string;
    ctaLabel: string;
    redirectTo: string;
  };
}

export const RENEWAL_FORM_QUESTIONS_CASE_A: Question[] = [
  {
    id: 407,
    key: "isCapacityAugmentationPlanned",
    label:
      "Whether there is any proposal under consideration or implementation for capacity augmentation (e.g., widening to 4-lane or more) on the selected National Highway?",
    type: "radio",
    // yesAction: {
    //   message:
    //     "Renewal is not permitted as a capacity augmentation proposal exists for this location. Please submit a fresh application?",
    //   ctaLabel: "Submit New Application",
    //   redirectTo: "/dashboard",
    // },
  },
  {
    id: 409,
    key: "isComplyingWithConditions",
    label:
      "Whether the applicant undertakes that the facility complies with the conditions of approved access permission and prescribed norms?",
    type: "radio",
  },
  {
    id: 411,
    key: "isDeviationDone",
    label:
      "Whether any deviation or modification has been carried out from the approved access permission?",
    type: "radio",
  },
  {
    id: 413,
    key: "isAccessSafe",
    label:
      "Whether the access (entry/exit) to the National Highway is safe for traffic movement and adequate visibility is available?",
    type: "radio",
  },
  {
    id: 415,
    key: "isEncroachmentPresent",
    label:
      "Whether there is any encroachment on Right of Way (ROW) or any unauthorized access/change?",
    type: "radio",
  },
  {
    id: 501,
    key: "renewal_description",
    label: "Brief Description",
    type: "text",
  },
];

export const RENEWAL_FORM_QUESTIONS_CASE_B: Question[] = [
  {
    id: 417,
    key: "isCapacityAugmentationPlanned",
    label:
      "Whether there is any proposal under consideration or implementation for capacity augmentation (e.g., widening to 4-lane or more) on the selected National Highway?",
    type: "radio",
    // yesAction: {
    //   message:
    //     "Renewal is not permitted as a capacity augmentation proposal exists for this location. Please submit a fresh application?",
    //   ctaLabel: "Submit New Application",
    //   redirectTo: "/dashboard",
    // },
  },
  {
    id: 419,
    key: "isComplyingWithConditions",
    label:
      "Whether the applicant undertakes that the facility complies with the conditions of approved access permission and prescribed norms?",
    type: "radio",
  },
  {
    id: 421,
    key: "isDeviationDone",
    label:
      "Whether any deviation or modification has been carried out from the approved access permission?",
    type: "radio",
  },
  {
    id: 423,
    key: "isAccessSafe",
    label:
      "Whether the access (entry/exit) to the National Highway is safe for traffic movement and adequate visibility is available?",
    type: "radio",
  },
  {
    id: 425,
    key: "isEncroachmentPresent",
    label:
      "Whether there is any encroachment on Right of Way (ROW) or any unauthorized access/change?",
    type: "radio",
  },
  {
    id: 501,
    key: "renewal_description",
    label: "Brief Description",
    type: "text",
  },
];

export const RENEWAL_FORM_QUESTIONS_CASE_C: Question[] = [
  {
    id: 408,
    key: "isUtilityMaintained",
    label:
      "Whether the utility services are being operated and maintained in accordance with the permission/license conditions?",
    type: "radio",
  },
  {
    id: 410,
    key: "isViolationPresent",
    label:
      "Whether there is violation of any condition of the permission/license agreement?",
    type: "radio",
  },
  {
    id: 412,
    key: "isUtilityAsPerAlignment",
    label:
      "Whether the utility is laid and continues to exist at the approved alignment?",
    type: "radio",
  },
  {
    id: 414,
    key: "isRestorationDone",
    label:
      "Whether restoration of trenching/road surface has been carried out and maintained properly?",
    type: "radio",
  },
  {
    id: 416,
    key: "isTrafficUnaffected",
    label:
      "Whether the utility installation does not interfere with traffic movement and safety?",
    type: "radio",
  },
  {
    id: 501,
    key: "renewal_description",
    label: "Brief Description",
    type: "text",
  },
];

export const RENEWAL_FORM_QUESTIONS_CASE_D: Question[] = [
  {
    id: 418,
    key: "isUtilityMaintained",
    label:
      "Whether the utility services are being operated and maintained in accordance with the permission/license conditions?",
    type: "radio",
  },
  {
    id: 420,
    key: "isViolationPresent",
    label:
      "Whether there is violation of any condition of the permission/license agreement?",
    type: "radio",
  },
  {
    id: 422,
    key: "isUtilityAsPerAlignment",
    label:
      "Whether the utility is laid and continues to exist at the approved alignment?",
    type: "radio",
  },
  {
    id: 424,
    key: "isRestorationDone",
    label:
      "Whether restoration of trenching/road surface has been carried out and maintained properly?",
    type: "radio",
  },
  {
    id: 426,
    key: "isTrafficUnaffected",
    label:
      "Whether the utility installation does not interfere with traffic movement and safety?",
    type: "radio",
  },
  {
    id: 501,
    key: "renewal_description",
    label: "Brief Description",
    type: "text",
  },
];

export const RENEWAL_FORM_QUESTIONS_CASE_E: Question[] = [
  {
    id: 427,
    key: "isUtilityMaintained",
    label:
      "Whether the utility services are being operated and maintained in accordance with the permission/license conditions?",
    type: "radio",
  },
  {
    id: 428,
    key: "isViolationPresent",
    label:
      "Whether there is violation of any condition of the permission/license agreement?",
    type: "radio",
  },
  {
    id: 429,
    key: "isUtilityAsPerAlignment",
    label:
      "Whether the utility is laid and continues to exist at the approved alignment?",
    type: "radio",
  },
  {
    id: 430,
    key: "isRestorationDone",
    label:
      "Whether restoration of trenching/road surface has been carried out and maintained properly?",
    type: "radio",
  },
  {
    id: 431,
    key: "isTrafficUnaffected",
    label:
      "Whether the utility installation does not interfere with traffic movement and safety?",
    type: "radio",
  },
  {
    id: 501,
    key: "renewal_description",
    label: "Brief Description",
    type: "text",
  },
];
